import React from 'react';
import { Hero, SocialProof, TestimonialsHero } from './components/Hero';
import { PainPoints, ProductIntro } from './components/PainPoints';
import { TomosGrid, BonusesGrid } from './components/ProductDetails';
import { PricingSection, ComparisonTable } from './components/Pricing';
import { TestimonialsExtended, Guarantee, FAQ, Footer } from './components/FooterSections';
import { PurchasePopup } from './components/PurchasePopup';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="min-h-screen bg-cream text-stone-900 font-sans selection:bg-coral-500/30 selection:text-coral-900" data-id="element-0" data-mp="2mn5ash5h0lgp">
      <MetaPixel data-id="element-1" data-mp="31c1igd3m7wgs" />
      <Hero data-id="element-2" data-mp="31cjp83nwlt2y" />
      <SocialProof data-id="element-3" data-mp="2wka0us2ft12s" />
      <TestimonialsHero data-id="element-4" data-mp="2wjqgz5t882m4" />
      <PainPoints data-id="element-5" data-mp="2wiferaffj2x4" />
      <ProductIntro data-id="element-6" data-mp="2whx9xpepbgdl" />
      <TomosGrid data-id="element-7" data-mp="28ufo0ai4bcij" />
      <BonusesGrid data-id="element-8" data-mp="28tw4wqgqei2x" />
      <PricingSection data-id="element-9" data-mp="28te3lff7pdo5" />
      <ComparisonTable data-id="element-10" data-mp="28sl3gxardmez" />
      <TestimonialsExtended data-id="element-11" data-mp="28s2z1ddy01vz" />
      <Guarantee data-id="element-12" data-mp="23vul23bheeqe" />
      <FAQ data-id="element-13" data-mp="23u9q4cl98ts0" />
      <Footer data-id="element-14" data-mp="23utbk3a460as" />

      <PurchasePopup data-id="element-15" data-mp="23t8heerpojdg" />
    </div>;
}